import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentMethodCurrencyConverterRequest } from '@/models/ps-management/currency-converter.model';

export default class UpdatePaymentMethodCurrencyConverterRequest extends ApiResourceMethod<{}> {
  public perform({ paymentMethodId, ...restParams }: PaymentMethodCurrencyConverterRequest): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${paymentMethodId}/currencyConverterList`,
        data: restParams,
      },
      ({ data }: BaseResponse<{}>) => data,
    );
  }
}
